import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=298677e0&scoped=true&"
import script from "./CartModal.vue?vue&type=script&lang=js&"
export * from "./CartModal.vue?vue&type=script&lang=js&"
import style0 from "./CartModal.vue?vue&type=style&index=0&id=298677e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298677e0",
  null
  
)

export default component.exports